import { withInstall } from '@tw-element/utils'

import PageHeader from './src/page-header.vue'

export const TwPageHeader = withInstall(PageHeader)
export default TwPageHeader

export * from './src/page-header'
